class StringHelper {

    static ToLabelForApi(input: string | null | undefined): string {
        if (input === null || input === undefined || input.trim() === "") {
            return "";
        }

        let result = input.replace(/[\s-]+/g, "_");
        result = result.normalize("NFD").replace(/[\u0300-\u036f]/g, "").normalize("NFC");
        result = result.replace(/[^a-zA-Z0-9_]/g, "");
        result = result.replace(/^_+|_+$/g, "");

        return result;
    }

    static isValidApiLabel(value: string | null | undefined): boolean {
        if (value === null || value === undefined) {
            return false;
        }

        const trimmed = value.trim();
        if (trimmed.length === 0) {
            return false;
        }

        // R�gle : seulement [A-Za-z0-9_], pas d'underscore d�but/fin
        const apiLabelRegex = /^(?!_)([A-Za-z0-9_]+)(?<!_)$/;

        return apiLabelRegex.test(trimmed);
    }
}

export default StringHelper;